import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoggedInUser } from '../../../../../../core/models/logged-in-user';
import { Observable, of, switchMap, tap } from 'rxjs';
import { LoggedInUserStateService } from '../logged-in-user-state/logged-in-user-state.service';
import { ApiRouteConstants } from '../../../../../../core/constants/api-routes';

@Injectable({
    providedIn: 'root',
})
export class LoggedInUserService {
    constructor(
        private readonly http: HttpClient,
        private readonly executorStateService: LoggedInUserStateService,
    ) {}

    getFreshLoggedInUserInformation(): Observable<LoggedInUser> {
        return this.http
            .get<LoggedInUser>(ApiRouteConstants.User.loggedInUser)
            .pipe(
                tap((executor) => {
                    this.executorStateService.setLoggedInUser(executor);
                }),
            );
    }

    getLoggedInUserInformation(): Observable<LoggedInUser> {
        return this.executorStateService.getLoggedInUser().pipe(
            switchMap((loggedInUser: LoggedInUser | null) => {
                if (loggedInUser) {
                    return of(loggedInUser);
                } else {
                    return this.getFreshLoggedInUserInformation();
                }
            }),
        );
    }
}
